export default __webpack_public_path__ + "static/media/NotoSans-Regular.e962f548.ttf";